import GenericRequest, { METHOD_POST } from '../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../shared/webservices/endpoint';

export class OutsourceSearchTask extends GenericRequest {

    _request; // OutsourceSearchRequest

    constructor(request) {
        super(METHOD_POST, ApiEndpoints.COMPANIES);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }

}



// WEBPACK FOOTER //
// ./src/app/my-outsources/outsource/list/outsource-search/OutsourceSearchTask.js